import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const NotificationIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 14 16" },
        React.createElement("path", { d: "M4.57811 14.1225C4.49754 13.8081 4.74637 13.5001 5.07093 13.5001H8.92907C9.25363 13.5001 9.50246 13.8081 9.42189 14.1225C9.14525 15.2021 8.16583 16.0001 7 16.0001C5.83417 16.0001 4.85475 15.202 4.57811 14.1225ZM12 7.08002V5.00006C12 3.0048 10.1237 2.06024 7.27983 0.185529C7.1132 0.0756894 6.88681 0.0756894 6.72018 0.185529C3.87628 2.06024 2 3.0048 2 5.00006V7.08002C2 9.96002 0 9.78003 0 10.92V11.5001C0 11.78 0.21997 12.0001 0.5 12.0001H13.5C13.78 12.0001 14 11.78 14 11.5001V10.92C14 9.78004 12 9.96003 12 7.08002Z" })));
};

export { NotificationIcon };
//# sourceMappingURL=NotificationIcon.esm.js.map
